var NULL_RANGE = {
  minValue: null,
  maxValue: null
};

export { NULL_RANGE };
//# sourceMappingURL=constants.esm.js.map
